const danceImg = [
  {
    title: 'National Youth Dance Company',
    img: 'https://i.imgur.com/zdysXqv.jpg',
  },
  {
    title: 'Semperoper Ballett',
    img: 'https://i.imgur.com/Bkj8s6c.jpg',
  },
  {
    title: 'Scapino Ballet',
    img: 'https://i.imgur.com/HlZTkko.jpg',
  },
  {
    title: 'Jacob O`Connell',
    img: 'https://i.imgur.com/yHbXvlI.jpg',
  },
  {
    title: 'Semperoper Ballett',
    img: 'https://i.imgur.com/xjWDmcW.jpg',
  },
  {
    title: 'Rambert',
    img: 'https://i.imgur.com/obcJS8O.jpg',
  },
  {
    title: 'Rambert',
    img: 'https://i.imgur.com/KUBhqs0.jpg',
  },
  {
    title: 'Theo Clinkard',
    img: 'https://i.imgur.com/7L7LXiY.jpg',
  },
  {
    title: 'Becky Namgauds',
    img: 'https://i.imgur.com/iJMWHBf.jpg',
  },
  {
    title: 'Mbulelo Ndabeni',
    img: 'https://i.imgur.com/UAKgl0k.jpg',
  },
  {
    title: 'Step Change Studios',
    img: 'https://i.imgur.com/taACeks.jpg',
  },
  {
    title: 'Royal Ballet',
    img: 'https://i.imgur.com/kauD19O.jpg',
  },
  {
    title: 'Anthony Matsena',
    img: 'https://i.imgur.com/iXCU79i.jpg',
  },
  {
    title: 'Theo Clinkard',
    img: 'https://i.imgur.com/pNCyxnO.jpg',
  },
  {
    title: 'Satchie Noro & Silvain Ohl',
    img: 'https://i.imgur.com/JkDD5fy.jpg',
  },
  {
    title: 'Arielle Smith',
    img: 'https://i.imgur.com/NpBoQGB.jpg',
  },
  {
    title: 'Semperoper Ballett',
    img: 'https://i.imgur.com/t5tD6HX.jpg',
  },
  {
    title: 'Rambert2',
    img: 'https://i.imgur.com/BxkG9Me.jpg',
  },
  {
    title: 'Cunningham Company',
    img: 'https://i.imgur.com/bLCwf7D.jpg',
  },
  {
    title: 'Theo Clinkard',
    img: 'https://i.imgur.com/CCTnCVS.jpg',
  },
  {
    title: 'Rambert2',
    img: 'https://i.imgur.com/V51WOPN.jpg',
  },
  {
    title: 'Jacob O`Connell',
    img: 'https://i.imgur.com/DFT3jkT.jpg',
  },
  {
    title: 'Pierre Rigal',
    img: 'https://i.imgur.com/sOyDx0O.jpg',
  },
  {
    title: 'Kirils Burlovs',
    img: 'https://i.imgur.com/8f5HiPl.jpg',
  },
  {
    title: 'Rambert',
    img: 'https://i.imgur.com/aiPfmbm.jpg',
  },
  {
    title: 'Rambert',
    img: 'https://i.imgur.com/ZmPOYnT.jpg',
  },
  {
    title: 'Rambert',
    img: 'https://i.imgur.com/hOtFFmX.jpg',
  },
  {
    title: 'Candoco Dance Company',
    img: 'https://i.imgur.com/S1XrLmP.jpg',
  },
  {
    title: 'Ballet Boys',
    img: 'https://i.imgur.com/YBijwky.jpg',
  },
  {
    title: 'Sadler`s Wells Young Associates',
    img: 'https://i.imgur.com/8pO9i2g.jpg',
  },
];

export default danceImg;
